// Module
var code = `<input
  type="password"
  name="password"
  ng-model="\$ctrl.model"
  ng-disabled="\$ctrl.ngDisabled"
  ng-required="\$ctrl.ngRequired"
  ui-validate="{
      oneNumber: '\$ctrl.validate(\$value, \\'ONE_NUMBER\\')',
      oneLowercaseLetter: '\$ctrl.validate(\$value, \\'ONE_LOWERCASE_LETTER\\')',
      oneUppercaseLetter: '\$ctrl.validate(\$value, \\'ONE_UPPERCASE_LETTER\\')',
      oneSpecialCharacter: '\$ctrl.validate(\$value, \\'ONE_SPECIAL_CHARACTER\\')'
    }"
  ui-validate-watch="'\$ctrl.form.password'"
  ng-minlength="\$ctrl.complexityRules.minLength"
  autocomplete="new-password"/>
<div ng-if="\$ctrl.form.password.\$invalid && !\$ctrl.form.password.\$error.required">
  <span>Password should have at least {{\$ctrl.getErrorMessage()}}</span>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/password/password.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;